module.exports = __webpack_public_path__ + "media/images/team-1-51a28acb.png";